import valueFilters from '../valueFilters';
import validator from '../validator';

export interface IPerson {
	firstName?: string;
	lastName?: string;
	fullName?: string;
	emailAddress?: string;
	avatarUrl?: string;
}

const person = {
	firstName: {
		rules: validator.required(),
		setFilters: function (val) {
			this._autoFillFullName(val, this.lastName);
			return val;
		}
	},
	lastName: {
		rules: validator.required(),
		setFilters: function (val) {
			this._autoFillFullName(this.firstName, val);
			return val;
		}
	},
	fullName: {
		setFilters: valueFilters.clean,
		rules: validator.required()
	},
	emailAddress: {
		setFilters: valueFilters.clean,
		rules: validator.email(true) // allow undefined
	},
	avatarUrl: {
		setFilters: valueFilters.clean
	},
	_autoFillFullName: function (firstName, lastName) {
		this.fullName = [firstName, lastName].join(' ');
	}
};

export default person;